/**
 * Fired after a successful Account → Profile save so chrome (TopBar +
 * SidebarUserFooter) can refresh name/avatar without a full page reload.
 */

export const PROFILE_UPDATED_EVENT = 'buzzbit:profile-updated';

export interface ProfileUpdatedDetail {
  name?: string;
  avatar?: string | null;
}

export function notifyProfileUpdated(detail: ProfileUpdatedDetail): void {
  window.dispatchEvent(new CustomEvent<ProfileUpdatedDetail>(PROFILE_UPDATED_EVENT, { detail }));
}
